import {Share} from "@mui/icons-material";
import {IconButton, Snackbar} from "@mui/material";
import * as React from "react";
import {useLocalization} from "@smalox/shared";

interface LinkShareIconButtonProps {
	title: string;
	text: string;
	url: string;
}

export function LinkShareIconButton({title, text, url}: Readonly<LinkShareIconButtonProps>) {
	const {t} = useLocalization();

	const [open, setOpen] = React.useState(false);

	const handleShare = async () => {
		let data = {
			title,
			text,
			url,
		};

		if (navigator.share && navigator.canShare(data)) {
			await navigator.share(data);
		}
		else {
			await navigator.clipboard.writeText(url);
			setOpen(true);
		}
	};

	return (
		<>
			<IconButton onClick={handleShare}>
				<Share />
			</IconButton>
			<Snackbar
				open={open}
				autoHideDuration={4000}
				onClose={() => setOpen(false)}
				message={t("copiedToClipboard")}
				anchorOrigin={{horizontal: "right", vertical: "bottom"}}
			/>
		</>
	);
}
